import { Fragment, jsx } from "react/jsx-runtime";
import { useIsClient } from "@crehana/react-hooks";
const ClientSideComponent = ({ children, fallback })=>{
    const isClient = useIsClient();
    if (!isClient) {
        if (fallback) return /*#__PURE__*/ jsx(Fragment, {
            children: fallback
        });
        return null;
    }
    return /*#__PURE__*/ jsx(Fragment, {
        children: children
    });
};
const src_ClientSideComponent = ClientSideComponent;
export default src_ClientSideComponent;
export { ClientSideComponent };
